var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout", { attrs: { "no-sidebar": true } }, [
    _c("h3", { staticClass: "mb-2 page-header" }, [
      _c("i", { staticClass: "s-icon fa fa-cog mr-3" }),
      _vm._v("Settings")
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "mb-3 d-flex flex-wrap align-items-center gap-2 group-filter-bar"
      },
      [
        _c("span", { staticClass: "text-muted mr-2 filter-label" }, [
          _vm._v("Filter by group:")
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-sm",
            class:
              _vm.selectedGroup === null
                ? "btn-primary"
                : "btn-outline-secondary",
            on: {
              click: function($event) {
                _vm.selectedGroup = null
              }
            }
          },
          [_vm._v("\n            All\n        ")]
        ),
        _vm._v(" "),
        _vm._l(_vm.groups, function(group) {
          return _c(
            "button",
            {
              key: group,
              staticClass: "btn btn-sm",
              class:
                _vm.selectedGroup === group
                  ? "btn-primary"
                  : "btn-outline-secondary",
              on: {
                click: function($event) {
                  _vm.selectedGroup = group
                }
              }
            },
            [_vm._v("\n            " + _vm._s(group) + "\n        ")]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mb-4" }, [
      _c(
        "div",
        {
          staticClass: "table-body row justify-content-center",
          staticStyle: { "max-width": "100%" }
        },
        [
          _c(
            "div",
            { staticClass: "col-sm-10", staticStyle: { "max-width": "100%" } },
            [
              _c("div", { staticClass: "margin-bottom-3x" }, [
                _c("div", { staticClass: "table-responsive" }, [
                  _vm.processing
                    ? _c("div", { staticClass: "text-center py-5" }, [
                        _c("i", {
                          staticClass: "fa fa-circle-o-notch fa-spin fa-2x"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-2 text-muted" }, [
                          _vm._v("Loading settings...")
                        ])
                      ])
                    : _c(
                        "table",
                        { staticClass: "table table-hover settings-table" },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("Setting")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Group")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Value")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Description")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.filteredSettings, function(
                                setting,
                                index
                              ) {
                                return _c(
                                  "tr",
                                  { key: index, staticClass: "setting-row" },
                                  [
                                    _c("td", [
                                      _c(
                                        "div",
                                        { staticClass: "setting-label" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "setting-key" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatKey(setting.key)
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      setting.group
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-secondary group-badge"
                                            },
                                            [_vm._v(_vm._s(setting.group))]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "text-muted" },
                                            [_vm._v("—")]
                                          )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "div",
                                        { staticClass: "setting-value" },
                                        [
                                          setting.type === "boolean"
                                            ? _c("editable-radio", {
                                                directives: [
                                                  {
                                                    name: "hasPermits",
                                                    rawName:
                                                      "v-hasPermits:allow",
                                                    value: ["super_admin"],
                                                    expression:
                                                      "['super_admin']",
                                                    arg: "allow"
                                                  }
                                                ],
                                                staticClass: "mb-0",
                                                attrs: {
                                                  value: setting.value,
                                                  options: {
                                                    1: "True",
                                                    0: "False"
                                                  }
                                                },
                                                on: {
                                                  valueSaved: function(data) {
                                                    return _vm.onEditSetting(
                                                      data,
                                                      setting
                                                    )
                                                  }
                                                }
                                              })
                                            : setting.type === "list"
                                            ? _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "hasPermits",
                                                      rawName:
                                                        "v-hasPermits:allow",
                                                      value: ["super_admin"],
                                                      expression:
                                                        "['super_admin']",
                                                      arg: "allow"
                                                    }
                                                  ],
                                                  on: {
                                                    change: function(data) {
                                                      return _vm.onEditSetting(
                                                        data,
                                                        setting
                                                      )
                                                    }
                                                  }
                                                },
                                                _vm._l(setting.value, function(
                                                  option
                                                ) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: option.key,
                                                      domProps: {
                                                        value: option.key,
                                                        selected:
                                                          option.selected === 1
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(option.value) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  )
                                                }),
                                                0
                                              )
                                            : _c("editable-text", {
                                                directives: [
                                                  {
                                                    name: "hasPermits",
                                                    rawName:
                                                      "v-hasPermits:allow",
                                                    value: ["super_admin"],
                                                    expression:
                                                      "['super_admin']",
                                                    arg: "allow"
                                                  }
                                                ],
                                                staticClass: "mb-0",
                                                attrs: { value: setting.value },
                                                on: {
                                                  valueSaved: function(data) {
                                                    return _vm.onEditSetting(
                                                      data,
                                                      setting
                                                    )
                                                  }
                                                }
                                              })
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "setting-description" },
                                      [
                                        setting.description
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(setting.description)
                                              )
                                            ])
                                          : _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [_vm._v("—")]
                                            )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              !_vm.filteredSettings.length
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "text-center text-muted py-3",
                                        attrs: { colspan: "4" }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-info-circle mr-1"
                                        }),
                                        _vm._v(
                                          "No settings found\n                                    "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                ])
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25fd5c1a", { render: render, staticRenderFns: staticRenderFns })
  }
}